import { useState, useEffect } from "react";
import { Form, Card, Row, Col, Button, Spinner } from "react-bootstrap";
import bsCustomFileInput from "bs-custom-file-input";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import Swal from "sweetalert2";
import { useRef } from "react";

import { validation } from "../utils/validation";
import { meses, modelos, remiserias } from "../constantes/constantes";
import { postSolicitud } from "../services/solicitud.service";
import ReactSelect from "react-select";

const Formulario = () => {
  const [loading, setLoading] = useState();
  const [agencia, setAgencia] = useState("");
  const [domicilio, setDomicilio] = useState("");
  const [oficio, setOficio] = useState("REMIS");
  const [check, setCheck] = useState(false);

  const date = new Date();
  const today = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;

  const refInput = useRef();

  const {
    register,
    setValue,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validation),
  });

  useEffect(() => {
    bsCustomFileInput.init();
  }, []);


  const onsumbit = async (data) => {
    if (oficio === "REMIS" && !agencia) {
      return refInput.current.focus();
    }
    data.agencia = agencia;
    data.agencia_domicilio = domicilio;

    setLoading(true);
    let response = await postSolicitud(data);
    if (response.status === 200) {
      setLoading(false);
      Swal.fire(
        "Exito",
        "Su solicitud fue enviada con exito.",
        "success"
      )
    }
    else {
      setLoading(false);
      if (response.response.data === "Tramite en proceso") {
        Swal.fire(
          "Error",
          "Este dominio ya tiene registrado una misma solicitud en proceso, porfavor espere que la procesen y le envien una respuesta.",
          "error",
        )
      } else {
        Swal.fire(
          "Error",
          "Ocurrió un error al registrar la solicitud. Intente nuevamente",
          "error",
        )
      }
    }
    setLoading(false);
  };

  const handleChange = (e) => {
    if (e.value) {
      let findDomicilio = remiserias.find(r => r.value === e.value)
      setAgencia(e.value);
      setDomicilio(findDomicilio?.domicilio);
    }
    else {
      setAgencia("");
      setDomicilio("");
    }
  };

  if (loading) {
    return (
      <div
        className='d-flex justify-content-center align-items-center flex-column mt-5'
        style={{ minHeight: '60vh' }}
      >
        <Button variant='primary' disabled>
          <Spinner
            as='span'
            animation='grow'
            size='sm'
            role='status'
            aria-hidden='true'
            className='mr-2'
          />
          Enviando...
        </Button>
      </div>
    );
  }

  return (
    <>
      <Form
        className="container mt-5 mb-5 form"
        onSubmit={handleSubmit(onsumbit)}
      >
        <Card className="shadow mb-5 bg-white rounded form__card">
          <Card.Header className="form__card--header d-flex justify-content-center">
            Solicitud de inscripción de remis y taxi
          </Card.Header>
          <Card.Body className="text-uppercase">
            <Form.Group>
              <Row className="justify-content-between">
                <Col sm={6} md={2} className="mb-2 mt-2 d-flex flex-row">
                  <Form.Label className="d-flex align-items-center m-0">Año:</Form.Label>
                  <Form.Control
                    className="ms-2"
                    name="año"
                    value={date.getFullYear()}
                    {...setValue("año", date.getFullYear())}
                    disabled />
                </Col>
                <Col sm={12} md={4} className="mb-2 mt-2 d-flex flex-row">
                  <Form.Label className="d-flex align-items-center m-0">Vencimiento:</Form.Label>
                  <Form.Control
                    className="ms-2"
                    name="vencimiento"
                    value={`${meses[date.getUTCMonth()].toUpperCase()} DE ${date.getFullYear() + 1}`}
                    {...setValue("vencimiento", `${meses[date.getUTCMonth()].toUpperCase()} DE ${date.getFullYear() + 1}`)}
                    disabled
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col className="mb-2 mt-2" sm={12} md={6}>
                  <Form.Label>C.U.I.T</Form.Label>
                  <Form.Control name="cuit" {...register("cuit")} className={`${errors.cuit ? "is-invalid" : ""}`} />
                  <Form.Control.Feedback type="invalid">{errors.cuit?.message}</Form.Control.Feedback>
                </Col>
                <Col sm={12} md={6} className="mb-2 mt-2">
                  <Form.Label>Email</Form.Label>
                  <Form.Control name="email" {...register("email")} type="email" className={`${errors.email ? "is-invalid" : ""}`} />
                  <Form.Control.Feedback type="invalid">{errors.email?.message}</Form.Control.Feedback>
                </Col>
              </Row>

              <Row className="mb-2">
                <Col className="mb-2 mt-2" sm={12} md={6}>
                  <Form.Label>Domicilio fiscal</Form.Label>
                  <Form.Control name="domicilio_fiscal" {...register("domicilio_fiscal")} className={`${errors.domicilio_fiscal ? "is-invalid" : ""}`} />
                  <Form.Control.Feedback type="invalid">{errors.domicilio_fiscal?.message}</Form.Control.Feedback>
                </Col>
                <Col sm={12} md={6} className="mb-2 mt-2">
                  <Form.Label>Telefono</Form.Label>
                  <Form.Control name="telefono" {...register("telefono")} className={`${errors.telefono ? "is-invalid" : ""}`} />
                  <Form.Control.Feedback type="invalid">{errors.telefono?.message}</Form.Control.Feedback>
                </Col>
              </Row>

              <div className="hr">
                <hr />
              </div>

              <Row className="mb-2">
                <Col className="mb-2 mt-2" sm={12} md={12}>
                  <Form.Label>Oficio o Actividad</Form.Label>
                  <Form.Select
                    name="oficio"
                    {...register("oficio", {
                      onChange: (e) => {
                        if (e.target.value === "TAXI") {
                          setAgencia("");
                          setDomicilio("");
                        }
                        setOficio(e.target.value)
                        return
                      }
                    })}
                  >
                    <option value="REMIS">REMIS</option>
                    <option value="TAXI">TAXI</option>
                  </Form.Select>
                </Col>
              </Row>

              <Row className="mb-2">
                <Col sm={12} md={2} className="mb-2 mt-2 d-flex align-items-center">
                  <Form.Label className="d-flex align-items-center m-0">Fecha de inscripción:</Form.Label>
                </Col>
                <Col sm={12} md={2} className="mb-2 mt-2">
                  <Form.Control
                    name="inscripcion"
                    value={today}
                    {...setValue("inscripcion", today)}
                    disabled
                  />
                </Col>
              </Row>

              <div className="hr">
                <hr />
              </div>

              <div className="subtitle"><span>Titular</span></div>
              <Row className="mb-2">
                <Col sm={12} md={6} className="mb-2 mt-2">
                  <Form.Label>Apellido</Form.Label>
                  <Form.Control name="lastname_titular" {...register("lastname_titular")} className={`${errors.lastname_titular ? "is-invalid" : ""}`} />
                  <Form.Control.Feedback type="invalid">{errors.lastname_titular?.message}</Form.Control.Feedback>
                </Col>
                <Col sm={12} md={6} className="mb-2 mt-2">
                  <Form.Label>Nombre</Form.Label>
                  <Form.Control name="firstname_titular"  {...register("firstname_titular")} className={`${errors.firstname_titular ? "is-invalid" : ""}`} />
                  <Form.Control.Feedback type="invalid">{errors.firstname_titular?.message}</Form.Control.Feedback>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col sm={12} md={6} className="mb-2 mt-2">
                  <Form.Label>DNI</Form.Label>
                  <Form.Control name="dni_titular" {...register("dni_titular")} className={`${errors.dni_titular ? "is-invalid" : ""}`} />
                  <Form.Control.Feedback type="invalid">{errors.dni_titular?.message}</Form.Control.Feedback>
                </Col>
                <Col sm={12} md={6} className="mb-2 mt-2">
                  <Form.Label>Domicilio</Form.Label>
                  <Form.Control name="domicilio_titular"  {...register("domicilio_titular")} className={`${errors.domicilio_titular ? "is-invalid" : ""}`} />
                  <Form.Control.Feedback type="invalid">{errors.domicilio_titular?.message}</Form.Control.Feedback>
                </Col>
              </Row>

              <div className="hr">
                <hr />
              </div>


              <div className="subtitle"><span>Datos del vehículo</span></div>
              <Row className="mb-2">
                <Col className="mb-2 mt-2" sm={12} md={6}>
                  <Form.Label>Marca</Form.Label>
                  <Form.Control name="marca" {...register("marca")} className={`${errors.marca ? "is-invalid" : ""}`} />
                  <Form.Control.Feedback type="invalid">{errors.marca?.message}</Form.Control.Feedback>
                </Col>
                <Col className="mb-2 mt-2" sm={12} md={6}>
                  <Form.Label>Modelo</Form.Label>
                  <Form.Select
                    name="modelo"
                    className={`${errors.modelo ? "is-invalid" : ""}`}
                    {...register("modelo")}
                  >
                    <option value="">ELIGE UN MODELO</option>
                    {modelos.map(años => {
                      return (
                        <option key={años} value={años}>{años}</option>
                      )
                    })}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">{errors.modelo?.message}</Form.Control.Feedback>
                </Col>
              </Row>

              <Row className="mb-2">
                <Col className="mb-2 mt-2" sm={12} md={4}>
                  <Form.Label>Dominio</Form.Label>
                  <Form.Control name="dominio" {...register("dominio")} className={`${errors.dominio ? "is-invalid" : ""}`} />
                  <Form.Control.Feedback type="invalid">{errors.dominio?.message}</Form.Control.Feedback>

                </Col>
                <Col className="mb-2 mt-2" sm={12} md={4}>
                  <Form.Label>Motor</Form.Label>
                  <Form.Control name="motor" {...register("motor")} className={`${errors.motor ? "is-invalid" : ""}`} />
                  <Form.Control.Feedback type="invalid">{errors.motor?.message}</Form.Control.Feedback>

                </Col>
                <Col className="mb-2 mt-2" sm={12} md={4}>
                  <Form.Label>Color</Form.Label>
                  <Form.Control name="color" {...register("color")} className={`${errors.color ? "is-invalid" : ""}`} />
                  <Form.Control.Feedback type="invalid">{errors.color?.message}</Form.Control.Feedback>
                </Col>
              </Row>

              {oficio === "REMIS" ? <Row className="mb-2">
                <Col className="mb-2 mt-2" sm={12} md={6}>
                  <Form.Label>Agencia</Form.Label>
                  {/* <Form.Select
                    name="agencia"
                    className={`${(oficio === "REMIS" && check && !agencia) ? "is-invalid" : ""}`}
                    onChange={handleChange}
                    ref={refInput}
                  >
                    <option value="">ELIGE UNA AGENCIA</option>
                    {
                      remiserias.map((remiseria, index) => {
                        return (
                          <option key={index} value={remiseria.agencia}>{remiseria.agencia}</option>
                        )
                      })
                    }
                  </Form.Select> */}
                  <Controller
                    control={control}     
                    render={({ field: { onChange, value } }) => {

                      return (
                        <ReactSelect
                          options={remiserias}
                          placeholder="Seleccionar"
                          className={`${(oficio === "REMIS" && check && !agencia) ? "is-invalid" : ""}`}
                          onChange={(e) => {
                            handleChange(e);
                            return onChange(e.value)
                          }}
                        />
                      )
                    }
                    }
                  />
                  {(oficio === "REMIS" && check && !agencia) && <Form.Control.Feedback type="invalid">Este campo es obligatorio</Form.Control.Feedback>}

                </Col>
                <Col className="mb-2 mt-2" sm={12} md={6}>
                  <Form.Label>Domicilio</Form.Label>
                  <Form.Control
                    value={domicilio}
                    name="agencia_domicilio"
                    disabled />
                </Col>
              </Row> : null}

            </Form.Group>
          </Card.Body>
          <Card.Footer>
            <div className="affirmation">
              <p>El que suscribe,
                <input name="propietario" {...register("propietario")} className={`mx-2 ${errors.propietario ? "invalid" : ""}`} />
                en su carácter de propietario afirma que los datos consignados en este formulario son correctos y completos, y que esta declaración se ha confeccionado sin omitir ni falsear dato alguno que deba contener, siendo fiel expresión de la verdad y pone a disposición de la Municipalidad todos los elementos necesarios para su verificación y control.-
              </p>
              {errors.propietario ? <div className="affirmation-message">{errors.propietario?.message}</div> : null}
            </div>

            <div className="d-flex justify-content-end mb-3 mt-5">
              <Card.Text className="me-3">
                San Nicolás, {today}
              </Card.Text>
            </div>
          </Card.Footer>
        </Card>

        <Button type="submit" variant="outline-primary" className="p-2 pl-4 pr-4 text-uppercase" onClick={() => setCheck(true)}>
          Enviar solicitud
        </Button>
      </Form>
    </>
  );
};

export default Formulario;
